import { POTypeEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { PoItemsDetails } from "./po-item-details.-create.dto";

export class PoDetailsDTO {
    @ApiProperty()
    vendorId:number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    purchaseOrderDate:Date;
    @ApiProperty()
    transportation:number;
    @ApiProperty()
    expectedDeliveryDate:Date;
    @ApiProperty()
    deliveryAddress:number;
    @ApiProperty()
    billingAddress:number;
    @ApiProperty()
    plantAddress:number;
    @ApiProperty()
    paymentTerms: number;
    @ApiProperty()
    shippingTerms: string;
    @ApiProperty()
    deliveryTerms: string;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    remarks:string;
    @ApiProperty()
    note:string;
    @ApiProperty()
    exchangeRate:number;
    @ApiProperty()
    indentNo?: string;
    @ApiProperty()
    qtnProformaInvNo?: string;
    @ApiProperty()
    proformaDate?: string;
    @ApiProperty()
    priceBasis?: string;
    @ApiProperty()
    dispatchInstructions?: string;
    @ApiProperty()
    dispatchedThrough?: string;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    updatedUser:string;
 
    @ApiProperty({enum:Object.values(POTypeEnum)})
    @IsNotEmpty()
    @IsEnum(POTypeEnum)
    poType: POTypeEnum; 

    @ApiProperty({type:[PoItemsDetails]})
    poItems:PoItemsDetails[];
    @ApiProperty()
    purchaseOrderId?:number;
    @ApiProperty()
    poNumber?:string;
    @ApiProperty({enum:Object.values(StatusEnum)})
    @IsNotEmpty()
    @IsEnum(StatusEnum)
    status?: StatusEnum; 
}